import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'attendance/time-tracking',
  children: {
    list: {
      path: 'list',
      size: 'full',
      children: {
        yearMonth: {
          path: ':year/:month',
          size: 'full',
          children: {
            list: {
              path: 'list',
              size: 'full',
              children: {
                exports: {
                  size: 'full',
                  path: 'exports',
                },
              },
            },
          },
        },
        periodTypeYearMonthDay: {
          size: 'full',
          path: ':periodType/:year/:month/:day',
          children: {
            exports: {
              size: 'full',
              path: 'exports',
            },
            exportYearlyBalance: {
              size: 'full',
              path: 'export-yearly-balance',
            },
            exclude: {
              size: 'full',
              path: 'exclude',
            },
          },
        },
      },
    },
    employee: {
      path: 'employee',
      children: {
        periodTypeYearMonthDayEmployeeId: {
          size: 'full',
          path: ':periodType/:year/:month/:day/:employeeId',
          children: {
            exports: {
              path: 'exports',
            },
            requestOvertime: {
              path: 'requestOvertime',
            },
            overtimeRequest: {
              path: 'overtimeRequest',
            },
            workedHoursBreakdownEmployeeId: {
              path: 'worked-hours-breakdown',
            },
            balanceBreakdownEmployeeId: {
              path: 'balance-breakdown',
            },
            compensationBreakdownEmployeeId: {
              path: 'compensation-breakdown',
            },
            bankOfHoursEmployeeId: {
              path: 'bank-of-hours-breakdown',
            },
          },
        },
        myProjects: {
          path: 'my-projects',
          children: {
            yearMonthDayEmployeeId: {
              size: 'full',
              path: ':year/:month/:day/:employeeId',
            },
          },
        },
      },
    },
  },
} as const satisfies Location
